import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const error = location.state?.error;

  useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-alabaster">
      <div className="hidden lg:flex relative bg-oxford text-white grain flex-col justify-between p-14">
        <div className="font-serif text-2xl tracking-tight relative">Aikyam</div>
        <div className="relative">
          <h1 className="font-serif text-4xl leading-tight">Admin Console</h1>
          <p className="mt-4 text-white/70 max-w-sm">
            Manage assessments, compare submissions, publish new workbook versions and administer access.
          </p>
        </div>
        <p className="text-white/40 text-xs relative">Authorized personnel only.</p>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2 text-gold mb-6">
            <ShieldCheck className="h-5 w-5" />
            <span className="overline text-gold">Secure Access</span>
          </div>
          <h2 className="font-serif text-3xl text-oxford">Sign in to continue</h2>
          <p className="mt-3 text-[var(--text2)] text-sm">
            Use your authorized Google account to access the Aikyam admin dashboard.
          </p>
          {error && (
            <div data-testid="login-error" className="mt-6 text-sm text-[var(--danger)] bg-red-50 border border-red-100 rounded-sm p-3">
              {error}
            </div>
          )}
          <Button data-testid="google-login-btn" onClick={login} className="btn-primary text-white w-full h-12 mt-8">
            <LogIn className="mr-2 h-4 w-4" /> Continue with Google
          </Button>
        </div>
      </div>
    </div>
  );
}
